var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.05942C8.16167 5.05942 6.66667 6.66692 6.66667 8.33358H8.33333C8.33333 7.50025 9.08083 6.72608 10 6.72608C10.8875 6.72608 11.6667 7.42025 11.6667 8.24442C11.6667 8.96275 11.1417 9.56692 10.3892 9.73442C9.68083 9.89275 9.16667 10.5261 9.16667 11.2603V12.5002H10.8333V11.3269C12.3092 10.9619 13.3333 9.72275 13.3333 8.24442C13.3333 6.50192 11.8067 5.05942 10 5.05942Z",
    fill: "#DC1928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 14.5833C8.75 13.8925 9.31 13.3333 10 13.3333C10.69 13.3333 11.25 13.8925 11.25 14.5833C11.25 15.2742 10.69 15.8333 10 15.8333C9.31 15.8333 8.75 15.2742 8.75 14.5833Z",
    fill: "#DC1928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.48583 4.48583 0 10 0C15.5142 0 20 4.48583 20 10C20 15.5142 15.5142 20 10 20C4.48583 20 0 15.5142 0 10ZM1.66667 10C1.66667 14.595 5.405 18.3333 10 18.3333C14.595 18.3333 18.3333 14.595 18.3333 10C18.3333 5.405 14.595 1.66667 10 1.66667C5.405 1.66667 1.66667 5.405 1.66667 10Z",
    fill: "#DC1928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.6fde782d8ad8b46338a966ca4dbe0e28.svg";
export { ForwardRef as ReactComponent };